import { Button, Modal, ModalBody } from "reactstrap";
import config from "../../config";
import { useEffect, useState } from "react";
import truckyService from "../../common/services/trucky-service";
import EnterpriseService from "../../common/services/enterprise-service";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";

export default function CMRJobDialog({ container, job, onClose }) {
  const [pdfUrl, setPdfUrl] = useState("");
  const es = new EnterpriseService();

  const loadPdfFromBytes = async () => {
    // Get byte array from HTTP
    const response = await es.getCMRPdf(job.id);

    // Convert to blob URL
    const blob = new Blob([response], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);

    setPdfUrl(url);
  };

  const downloadFile = () => {
    // Create download link
    const link = document.createElement("a");
    link.href = pdfUrl;
    link.download = `CMR_${job.id}.pdf`;

    // Trigger download
    document.body.appendChild(link);
    link.click();

    // Cleanup
    document.body.removeChild(link);
    URL.revokeObjectURL(url);
  };

  useEffect(() => {
    loadPdfFromBytes();
  }, []);

  return (
    <Modal
      isOpen={true}
      toggle={onClose}
      size="xl"
      className="big-modal"
      wrapClassName="big-modal-wrap"
      modalClassName="big-modal-container"
      contentClassName="big-modal-content"
    >
      <ModalBody>
        {pdfUrl && pdfUrl != "" && (
          <>
            <div className="d-flex justify-content-between mb-3">
              <h5 className="modal-title">
                {job.game_id == 1
                  ? container.localeManager.strings.cmr
                  : container.localeManager.strings.billOfLading}
              </h5>
              <div>
                <Button color="primary" onClick={downloadFile} className="me-3">
                  <FontAwesomeIcon
                    icon="download"
                    className="mx-0"
                  ></FontAwesomeIcon>
                </Button>
              </div>
            </div>
            <embed
              src={`${pdfUrl}#toolbar=0&navpanes=0&scrollbar=0`}
              type="application/pdf"
              width="100%"
              height="600px"
            />
          </>
        )}
      </ModalBody>
    </Modal>
  );
}
